import * as bootstrap from 'bootstrap';

import api from './ajax.js';
import renderJobHistory from "./render-job-history";
import updateJobCard from "./update-job-card";
import {jobTalliesManager} from './job-tallies-refactored';

// Role mapping from staff allocation roles to tally roles
const roleToTallyRole = {
	'Shearing': 'shearing_crutching',
	'Shearers': 'shearing_crutching',
	'Crutcher': 'shearing_crutching',
	'Woolhandler': 'woolhandler',
	'Classer': 'classer',
	'Contract Classer': 'classer',
	'Cross Bred Classer': 'classer',
	'Presser': 'presser',
	'Sheepo': 'sheepo',
	'Cook': 'cook'
};

// Define a variable to store the trigger element
let triggerElement = null;

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function () {
	// Get a reference to the modal
	const confirmationModal = document.getElementById('confirmationModal');

	if (!confirmationModal) {
		return;
	}

	// Listen for the modal to be shown
	confirmationModal.addEventListener('show.bs.modal', function (event) {
		// Store the triggering element
		triggerElement = event.relatedTarget;

		// Extract data attributes
		const title = triggerElement.getAttribute('data-sp-title');
		const message = triggerElement.getAttribute('data-sp-message');
		const jobId = triggerElement.getAttribute('data-sp-job');
		const confirmAction = triggerElement.getAttribute('data-sp-action'); // New: Action attribute

		// Populate the modal content
		const modalTitle = confirmationModal.querySelector('.modal-title');
		const modalBody = confirmationModal.querySelector('.modal-body p');

		if (modalTitle) modalTitle.textContent = title;
		if (modalBody) modalBody.textContent = message;

		// Optionally store the job ID and action in the modal for later use
		confirmationModal.setAttribute('data-sp-job-id', jobId);
		confirmationModal.setAttribute('data-sp-action', confirmAction);
	});

	// Handle confirm button click
	const confirmButton = confirmationModal.querySelector('.btn-primary');
	confirmButton.addEventListener('click', function () {
		const currentTriggerElement = triggerElement;
		const jobId = confirmationModal.getAttribute('data-sp-job-id');
		const confirmAction = confirmationModal.getAttribute('data-sp-action');

		if (confirmAction && currentTriggerElement) {
			// Perform the action
			if (confirmAction === 'removeStaffFromJob') {
				const staffId = currentTriggerElement.getAttribute('data-sp-staff');
				const roleId = currentTriggerElement.getAttribute('data-sp-role');
				const roleName = currentTriggerElement.getAttribute('data-sp-role-name');

				api.removeStaffFromJob(staffId, roleId, jobId).then(response => {
					if (response.error) {
						alert('An error occurred');
					} else {
						// Remove the staff row from the table
						const staffRow = currentTriggerElement.closest('tr');
						staffRow.remove();

						// Check if staff has zero tally data and offer to remove from tallies
						const tallyRoleId = roleToTallyRole[roleName];
						if (tallyRoleId && jobTalliesManager && jobTalliesManager.talliesData) {
							// Check if staff exists in tallies and has zero data
							if (jobTalliesManager.staffHasZeroDataAllDays(staffId, tallyRoleId)) {
								if (confirm('This staff member has no tally data recorded. Would you also like to remove them from the job tallies?')) {
									jobTalliesManager.removeStaffFromRole(staffId, tallyRoleId);
								}
							}
						}

						// Auto-save tallies after staff removal to persist the removed status
						setTimeout(() => {
							if (jobTalliesManager && jobTalliesManager.talliesData) {
								api.saveTallies(jobId, jobTalliesManager.talliesData).then(saveResponse => {
									if (saveResponse.error) {
										console.warn('Failed to auto-save tallies:', saveResponse.error);
									} else {
										console.log('Tallies auto-saved after staff removal');
									}
								});
							}
						}, 500); // Small delay to allow staff-allocation-watcher to mark staff as removed

						api.getJobHistory(jobId).then(response => {
							const jobHistoryList = $('#jobHistoryList');

							if (response.error) {
								return;
							}

							const jobHistoryHtml = renderJobHistory(response.body)

							jobHistoryList.html(jobHistoryHtml);

						});
					}
				});
			} else if (confirmAction === 'sendJob') {
				api.sendJob(jobId).then(response => {
					if (response.error) {
						alert('An error occurred');
					} else {
						const { body } = response;

						api.getJobHistory(jobId).then(response => {
							const jobHistoryList = $('#jobHistoryList');

							if (response.error) {
								return;
							}

							const jobHistoryHtml = renderJobHistory(response.body)

							jobHistoryList.html(jobHistoryHtml);

						});

					}
				});
			} else if (confirmAction === 'sendJobToClient' || confirmAction === 'sendJobToFarm') {
				api.sendJobToClient(jobId).then(response => {
					if (response.error) {
						alert('An error occurred');
					} else {
						const { body } = response;

						api.getJobHistory(jobId).then(response => {
							const jobHistoryList = $('#jobHistoryList');

							if (response.error) {
								return;
							}

							const jobHistoryHtml = renderJobHistory(response.body)

							jobHistoryList.html(jobHistoryHtml);

						});

					}
				});
			} else if (confirmAction === 'deleteJob') {
				window.location.href = `/jobs/${jobId}/delete/`;

			} else if (confirmAction === 'pauseJob') {
				api.pauseResumeJob(jobId, 'pause').then(response => {
					if (response.error) {
						alert('An error occurred');
					} else {
						const { body } = response;

						// Update job card based on the API response
						updateJobCard(jobId, body);

						api.getJobHistory(jobId).then(response => {
							const jobHistoryList = $('#jobHistoryList');

							if (response.error) {
								return;
							}

							const jobHistoryHtml = renderJobHistory(response.body)

							jobHistoryList.html(jobHistoryHtml);

						});

					}
				});
			} else if (confirmAction === 'resumeJob') {
				api.pauseResumeJob(jobId, 'resume').then(response => {
					if (response.error) {
						alert('An error occurred');
					} else {
						const { body } = response;

						// Update job card based on the API response
						updateJobCard(jobId, body);

						api.getJobHistory(jobId).then(response => {
							const jobHistoryList = $('#jobHistoryList');

							if (response.error) {
								return;
							}

							const jobHistoryHtml = renderJobHistory(response.body)

							jobHistoryList.html(jobHistoryHtml);

						});

					}
				});
			}
		}

		// Hide the modal
		const bootstrapModal = bootstrap.Modal.getInstance(confirmationModal);
		bootstrapModal.hide();
	});

	// Listen for the modal to be hidden
	confirmationModal.addEventListener('hidden.bs.modal', function () {
		// Reset the modal content
		const modalTitle = confirmationModal.querySelector('.modal-title');
		const modalBody = confirmationModal.querySelector('.modal-body p');

		if (modalTitle) modalTitle.textContent = '';
		if (modalBody) modalBody.textContent = '';

		// Remove any stored data attributes
		confirmationModal.removeAttribute('data-sp-job-id');
		confirmationModal.removeAttribute('data-sp-action');

		// Clear the stored trigger element
		triggerElement = null;
	});
});
